import script from "./PreguntaHotspot.vue?vue&type=script&setup=true&lang=js"
export * from "./PreguntaHotspot.vue?vue&type=script&setup=true&lang=js"

import "./PreguntaHotspot.vue?vue&type=style&index=0&id=5bcebed4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bcebed4"]])

export default __exports__